'use client'

import { useEffect, useState, useContext } from 'react'
import { ConsentContext } from '@/context/ConsentContext'
import { isPurMode } from '@/utils/app/paid'
import styles from './Outbrain.module.scss'
import { MetaDataContext } from '@/context/MetadataContext'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'

const Outbrain = ({ obId, className, cookies }: { obId: string; className?: string; cookies: RequestCookie[] }) => {
  const loadObScript = (): void => {
    const id = 'obScript'
    let scriptElem = window && window.document && (window.document.getElementById(id) as HTMLScriptElement)
    if (!scriptElem) {
      scriptElem = document.createElement('script')
      scriptElem.type = 'text/javascript'
      scriptElem.id = id
      scriptElem.async = true
      scriptElem.src = 'https://widgets.outbrain.com/outbrain.js'
      document.head.appendChild(scriptElem)
    }
  }

  const metaData = useContext(MetaDataContext)
  const consentContext = useContext(ConsentContext)

  const [obLocation, setObLocation] = useState('')
  useEffect(() => {
    setObLocation('https://www.n-tv.de' + window.location.pathname)

    if (
      !isPurMode(cookies) &&
      !metaData?.model.adsDisable &&
      !metaData?.model.isPreview &&
      consentContext.consentReady
    ) {
      loadObScript()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consentContext])

  return (
    <div
      className={`OUTBRAIN ${className} ${obId === 'AR_1' || obId === 'AR_47' ? styles.space : obId === 'SF_22' ? styles['sf-wrapper'] : undefined}`}
      data-src={obLocation}
      data-widget-id={obId}
    ></div>
  )
}

export default Outbrain
